import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Page } from "@/components/Page";
import { Text } from "@/components/Text";
import { useAdminCanEdit } from "./useAdminCanEdit";

/**
 * Frame for every admin section: the standard Page, with header actions
 * (Add user, ...) dropped and a view-only note shown when editing isn't
 * available (phones; see useAdminCanEdit).
 */
export function AdminPage({
  title,
  subtitle,
  actions,
  children,
}: Readonly<{ title: string; subtitle?: string; actions?: ReactNode; children: ReactNode }>) {
  const { t } = useTranslation("admin");
  const canEdit = useAdminCanEdit();
  return (
    <Page title={title} subtitle={subtitle} actions={canEdit ? actions : undefined}>
      {!canEdit && (
        <Text variant="caption" tone="secondary">
          {t("readOnlyMobile")}
        </Text>
      )}
      {children}
    </Page>
  );
}
